import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { AccountsClosedMessage } from "../components/AccountsClosed.js";
import { colors } from "@edufadder/ui";
import { useAuth } from "../lib/auth-context.js";
import { useRegistrationOpen } from "../lib/site.js";
import { ApiError } from "../lib/api.js";
import * as s from "../styles.js";

export function RegisterPage(): JSX.Element {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [displayName, setDisplayName] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);
  const registrationOpen = useRegistrationOpen();

  async function handleSubmit(e: React.FormEvent): Promise<void> {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await register(email, password, displayName);
      navigate("/", { replace: true });
    } catch (err) {
      setError(err instanceof ApiError ? err.message : "Registration failed.");
    } finally {
      setSubmitting(false);
    }
  }

  if (!registrationOpen) {
    return (
      <div style={s.container}>
        <h1 style={s.heading1}>Create an account</h1>
        <div role="status" style={{ ...s.card, maxWidth: 560, borderTop: `4px solid ${colors.gold}`, fontSize: 16, lineHeight: 1.6 }}>
          <AccountsClosedMessage />
        </div>
        <p style={{ ...s.mutedText, marginTop: 16 }}>
          Already have an account? <Link to="/login">Sign in</Link>
        </p>
      </div>
    );
  }

  return (
    <div style={s.container}>
      <h1 style={s.heading1}>Create an account</h1>
      <form onSubmit={(e) => void handleSubmit(e)} style={{ maxWidth: 360 }}>
        <label style={s.label}>
          Name
          <input style={s.input} required value={displayName} onChange={(e) => setDisplayName(e.target.value)} />
        </label>
        <label style={s.label}>
          Email
          <input style={s.input} type="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
        </label>
        <label style={s.label}>
          Password (at least 10 characters)
          <input
            style={s.input}
            type="password"
            required
            minLength={10}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </label>
        {error && <p style={s.errorText}>{error}</p>}
        <button type="submit" style={s.buttonPrimary} disabled={submitting}>
          {submitting ? "Creating account…" : "Create account"}
        </button>
      </form>
      <p style={{ ...s.mutedText, marginTop: 16 }}>
        Already have an account? <Link to="/login">Sign in</Link>
      </p>
    </div>
  );
}
